<section class="section-title">
  <div class="section-title-image">
    <img class="user-image" src="assets/img/user.png" />
  </div>

  <div class="section-title-text">
    <h1 *ngIf="!userCreated && canUserEdit" i18n="@@useradd_title">Aggiungi abbonamento</h1>

    <h1 *ngIf="userCreated && canUserEdit" i18n="@@useradd_title_alt">Modifica abbonamento</h1>


    <h1 *ngIf="!canUserEdit" i18n="@@useradd_title_service">Informazioni abbonamento</h1>
  </div>

  <a *ngIf="userCreated && canUserEdit" (click)="deleteUser()" class="button button-red" id="delete-user-button">
    <ng-container i18n="@@useradd_delete_user">Elimina abbonamento</ng-container>
    <span>
      <fa-icon icon="trash-alt"></fa-icon>
    </span>
  </a>
  <!-- <a (click)="loadWithUsers()" class="button button-green" id="delete-user-button">
    <ng-container i18n="@@useradd_delete_user">Auto crea utenti</ng-container>
    <span>
      <fa-icon icon="trash-alt"></fa-icon>
    </span>
  </a> -->
</section>

<section>
  <form [formGroup]="addUserForm">
    <table class="simple-table user-add-table">
      <tr>
        <td width="180px" class="text-dark" i18n="@@useradd_name">Nome</td>
        <ng-container *ngIf="canUserEdit">
          <td>
            <input id="name-input" formControlName="name" [(ngModel)]="username" />
          </td>
        </ng-container>
        <ng-container *ngIf="!canUserEdit">
          <td height="80px">
            <label class="td-label">{{username}}</label>
          </td>
        </ng-container>
      </tr>

      <tr>
        <td width="180px" class="text-dark" i18n="@@useradd_description">Descrizione</td>
        <ng-container *ngIf="canUserEdit">
          <td>
            <input id="description-input" formControlName="description" [(ngModel)]="description" />
          </td>
        </ng-container>
        <ng-container *ngIf="!canUserEdit">
          <td height="80px">
            <label class="td-label">{{description}}</label>
          </td>
        </ng-container>
      </tr>

      <tr *ngIf=userActivated>
        <td width="180px" height="80px" class="text-dark" i18n="@@useradd_email">Email</td>
        <td> <label class="td-label">{{this.userEmailAddress}}</label> </td>
      </tr>

      <tr>
        <td width="180px" class="text-dark" i18n="@@useradd_group">
          Gruppo
        </td>

        <ng-container *ngIf="canUserEdit">
          <td>
            <select id="group-select" formControlName="group" required (change)="isGroupSelected($event)"
              [(ngModel)]="usergroup">
              <option [ngValue]="group" *ngFor="let group of groupslist">{{group.name}}</option>
            </select>
          </td>
        </ng-container>

        <ng-container *ngIf="!canUserEdit">
          <td height="80px">
            <label class="td-label">{{usergroup.name}}</label>
          </td>
        </ng-container>
      </tr>
    </table>

    <div *ngIf=userCreated>

      <div class="margin-top-30">
        <!-- (activationCodes)="getUserActivationCodes($event)" -->
        <app-code-list [userOwnerId]="userOwnerId" [owner]="owner" [canUserEdit]="canUserEdit">
        </app-code-list>
      </div>

      <div class="margin-top-30">

        <div class="control-card-white">

          <div class="control-card-header">
            <ng-container i18n="@@useradd_activated_devices_title">Dispositivi attivati</ng-container>
          </div>

          <div class="control-card-content">

            <mat-tab-group [animationDuration]="'0ms'">

              <mat-tab label={{listString}}>
                <app-add-user-devices-list (onDeviceSelected)="onDeviceSelected($event)"
                  (onDeviceDeselected)="onDeviceDeselected($event)" (selectedDeviceEmitter)="onDeviceSelected($event)"
                  [deviceList]="deviceList" [groupSelected]="groupSelected"
                  [devicesWithExpiredPermissions]="devicesWithExpiredPermissions" [canUserEdit]="canUserEdit">
                </app-add-user-devices-list>
              </mat-tab>

              <mat-tab label={{mapString}}>
                <app-add-user-devices-map (onDeviceSelected)="onDeviceSelected($event)"
                  (onDeviceDeselected)="onDeviceDeselected($event)" (selectedDeviceEmitter)="onDeviceSelected($event)"
                  [deviceList]="deviceList" [groupSelected]="groupSelected" [canUserEdit]="canUserEdit">
                  <!-- [usergroup]="usergroup" -->
                </app-add-user-devices-map>
              </mat-tab>

            </mat-tab-group>

          </div>

        </div>

      </div>

      <div class="margin-top-30">
        <app-access-methods (accessMethods)="getAccessMethods($event)" [userOwnerId]="userOwnerId" [canUserEdit]="canUserEdit">
        </app-access-methods>
      </div>

      <div class="margin-top-30">

        <a (click)="createUser()" class="button user-add-button" *ngIf="canUserEdit">
          <ng-container i18n="@@useradd_save">Salva</ng-container>
          <span>
            <fa-icon icon="save"></fa-icon>
          </span>
        </a>

      </div>

    </div>

    <br>
    <br>
    <a (click)="createUser()" class="button user-add-button" *ngIf="!userCreated && canUserEdit">
      <ng-container i18n="@@useradd_create_user">Crea abbonamento</ng-container>
      <span>
        <fa-icon icon="save"></fa-icon>
      </span>
    </a>
    <p class="text-small text-error margin-top-10 display-inline" *ngIf="usernameError && userCreated"
      i18n="@@useradd_username_error">
      Inserire il nome utente
    </p>
    <p class="text-small text-error margin-top-10 display-inline" *ngIf="groupError && userCreated"
      i18n="@@useradd_group_error">
      Selezionare il gruppo
    </p>
    <p class="text-small text-error margin-top-10 display-inline" *ngIf="expiredPermissionsError && userCreated"
      i18n="@@useradd_expired_permissions_error">
      Almeno uno dei permessi inseriti è scaduto
    </p>
  </form>

  <app-loading-screen #adduserloader [showtext]="false"></app-loading-screen>

</section>